// libraries.
import { useState } from "react";

// components.
import { IconWarning } from "@assets";
import { StyledExceptionCard } from "../styles";
import { EditExceptionModal } from "./EditExceptionModal";

// store.
import { useRulesSlice } from "@store/apiSlices/incentiveRules/slices/rules";

// interfaces.
import { ExceptionRule } from "../rulesData";

export const ExceptionsTab = () => {
  const { exceptions } = useRulesSlice();
  const [editingException, setEditingException] =
    useState<ExceptionRule | null>(null);

  return (
    <>
      <div className="d-flex flex-column gap-3 mt-3">
        <p className="text-muted mb-1">
          Condiciones que excluyen al inmueble de la Ruta de Incentivos Default.
          Si alguna aplica, no se ejecutan las reglas de descuento.
        </p>

        {exceptions.map((exception) => (
          <StyledExceptionCard key={exception.id}>
            <div className="d-flex gap-3 align-items-start">
              <div className="exception-icon flex-shrink-0">
                <IconWarning fill="#FF5958" width="20" height="20" />
              </div>
              <div className="d-flex flex-column gap-2 flex-grow-1">
                <div className="d-flex align-items-center justify-content-between">
                  <span className="exception-title">{exception.name}</span>
                  <div className="d-flex align-items-center gap-2">
                    <span className="exception-badge">No aplica ruta</span>
                    <button
                      className="exception-edit-btn"
                      onClick={() => setEditingException(exception)}
                      title="Editar excepción"
                      disabled
                      style={{ opacity: 0, pointerEvents: "none" }}
                    >
                      ✏️
                    </button>
                  </div>
                </div>
                <p className="exception-description mb-0">
                  {exception.description}
                </p>
                <div className="d-flex gap-2 align-items-center">
                  <span
                    className="exception-description"
                    style={{ fontSize: "12px" }}
                  >
                    Campo: <strong>{exception.field}</strong> ={" "}
                    {exception.triggerValue}
                  </span>
                </div>
              </div>
            </div>
          </StyledExceptionCard>
        ))}
      </div>

      <EditExceptionModal
        exception={editingException}
        onClose={() => setEditingException(null)}
      />
    </>
  );
};
